import api from "./axios";

export async function getDevices() {
  const response = await api.get("/devices");
  return response;
}

export async function getSimplifiedDevices(orderId) {
  const response = await api.get(`/devices/simplifiedDevices/${orderId}`);
  return response;
}

export async function getDevice(deviceId) {
  const response = await api.get(`/devices/${deviceId}`);
  return response;
}

export async function postDevice(device) {
  const response = await api.post("/devices", device);
  return response;
}

export async function deleteDevice(deviceId) {
  const response = await api.delete(`/devices/${deviceId}`);
  return response;
}

export async function putDevice(device, deviceId) {
  const response = await api.put(`/devices/${deviceId}`, device);
  return response;
}
